export type LoginValues = {
    wsUrl: string;
    login: string;
    password: string;
};

export const WS_PREFIX = 'wss://';

export const isValidWsUrl = (wsUrl?: string | null): boolean => !(!wsUrl || wsUrl === '""' || wsUrl === 'undefined');

export const getPrepagedWsUrl = (wsUrl: string): string =>
    wsUrl.startsWith(WS_PREFIX) ? wsUrl.trim() : `${WS_PREFIX}${wsUrl.trim()}`;

export const getWSUrlWithoutPrefix = (wsUrl: string): string =>
    wsUrl.trim().slice(wsUrl.startsWith(WS_PREFIX) ? WS_PREFIX.length : 0);

export const MANAGER_API_PATH = '/api/manager';

// Derives the HTTPS manager API base from the WS URL. When the WS URL carries an explicit port we are
// on a direct deployment where Swagger is served on the access server's separate HTTPS manager port,
// so we swap that port in. With no explicit port (proxied, i.e. 443) the docs share the WS authority.
export const getManagerApiUrl = (wsUrl: string, httpsManagerPort?: number | null): string => {
    const parsed = new URL(getPrepagedWsUrl(wsUrl));
    const port = parsed.port && httpsManagerPort ? String(httpsManagerPort) : parsed.port;
    const host = port ? `${parsed.hostname}:${port}` : parsed.hostname;
    return `https://${host}${MANAGER_API_PATH}`;
};
